import type { StraightenerRecipeValueRow } from "../straightener-recipes/models/StraightenerRecipe";
import type { StraightenerTrendRow } from "./models/StraightenerTrend";

const key = (code: string, roll: number) => `${code}:${roll}`;

// Swaps the recipe side of the trend rows for another recipe's stored values,
// leaving the live readings untouched — that is what the screen compares
// against while an operator is looking at a recipe that is not current yet.
//
// The values come from MILL.GetStraightenerRecipeValues rather than from a
// second call to the trend procedure: that one reads the historian once per row
// and is polled every few seconds, and none of that work is needed to answer
// "what would this recipe set".
//
// A parameter the previewed recipe does not carry comes back empty on purpose:
// the recipe genuinely says nothing about it.
export const withPreviewedRecipe = (
	rows: StraightenerTrendRow[],
	previewValues: StraightenerRecipeValueRow[] | null | undefined,
): StraightenerTrendRow[] => {
	if (!previewValues) return rows;
	const byKey = new Map(
		previewValues.map((v) => [key(v.ParameterCode, v.RollNumber), v]),
	);
	return rows.map((r) => {
		const v = byKey.get(key(r.parameterCode, r.rollNumber));
		return {
			...r,
			recipe: v?.Value ?? null,
			min: v?.MinValue ?? null,
			max: v?.MaxValue ?? null,
		};
	});
};
